"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var copy_to_clipboard_1 = __importDefault(require("copy-to-clipboard"));
var clsx_1 = __importDefault(require("clsx"));
var react_2 = require("@fluentui/react");
require("./Forms.scss");
require("./CopyTextField.scss");
var CustomLabel_1 = require("./CustomLabel");
var CopyTextField = function (props) {
    var value = props.value, className = props.className, readOnly = props.readOnly, arabic = props.arabic, toolTip = props.toolTip, toolTipLink = props.toolTipLink, toolTipLinkOnClick = props.toolTipLinkOnClick, containerClassName = props.containerClassName, disabled = props.disabled, onCopy = props.onCopy, copiedTitle = props.copiedTitle;
    var _a = react_1.useState(false), copied = _a[0], setCopied = _a[1];
    var copyText = function () {
        copy_to_clipboard_1.default(value || '');
        setCopied(true);
        onCopy();
    };
    var useClassName = clsx_1.default('copyText', className, readOnly ? 'eta-cTextFieldReadOnly' : '', arabic ? 'rtlTextField' : '');
    var label = props.label;
    return (react_1.default.createElement("div", { className: clsx_1.default('vertialFlexDiv', containerClassName) },
        label && (react_1.default.createElement(CustomLabel_1.Label, { toolTip: toolTip, toolTipLink: toolTipLink, toolTipLinkOnClick: toolTipLinkOnClick }, label)),
        react_1.default.createElement("div", { className: "copyContainer" },
            react_1.default.createElement(react_2.TextField, __assign({}, props, { label: undefined, disabled: disabled, className: useClassName, value: value !== null && value !== void 0 ? value : '' })),
            react_1.default.createElement(react_2.IconButton, { iconProps: { iconName: 'Copy' }, onClick: function () { return copyText(); } })),
        copied && (react_1.default.createElement("div", { className: "flex" },
            react_1.default.createElement(react_2.Icon, { className: 'copiedIcon', iconName: 'CompletedSolid' }),
            react_1.default.createElement("span", null, copiedTitle)))));
};
exports.CopyTextField = CopyTextField;
//# sourceMappingURL=CopyTextField.js.map